import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Onest\",\"arguments\":[{\"weight\":[\"400\",\"600\"],\"subsets\":[\"latin\",\"latin-ext\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager", webpackExports: ["CookiesConsentPopup"] */ "/build/src/components/cookies-consent-popup/CookiesConsentPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DevToolbarClient"] */ "/build/src/components/dev-toolbar/DevToolbarClient.tsx");
;
import(/* webpackMode: "eager" */ "/build/src/styles/global.scss");
